'use strict';

module.exports = {
  socials: {
    facebook: {
      scope: 'public_profile,email,user_photos'
    },
  },
  recaptcha: {
    siteKey: '6LfcLzknAAAAANN80eI0YHL8dzQogOHcKe9Tamc4',
  },
  adyen: {
    key: '10001|951F016DA4C41968436586CA23472C2200CDD76CAD38B5F40043F25F5FAC2DDF2D07ED067DF14E5C61C21CB6772895E8E82DE2EB54B32272D79D5DB2CD1238923105F28789771C7D4837E1089B52B19A2EB19A0F421205CBB2DC7CB9D3ED10FE257E1F98DC51B018851F87F75137C79EA03B3F59A5E6427B494E40C588B081D0B1B57075343CD333D62710D4D5E66F95AD746213ADAD433C0D5717F9044775F234EF4C42709C23F312AFB962F4BDC6B9C4CC558C1D72E49BD08BB5E9EBAE793995DDC182111612F23A69DCFECBEF09A137475342E9EAE65C8254085D732884E3E1CC863B07C9CF7068293E270CA1B06AD3A2EAEC4AF7FA347DB0C09BBB1A720D'
  },
  socketUrl: 'https://showaround.com:31337',
  segmentApiKey: 'h3dEQbbwE3Kcv5qzSr4KVKKa5wpBO0SI',
  sentryDsn: 'https://a1687fa45ddf43899ec4a90842a09602@app.getsentry.com/43324',
  gaKeys: [
      {
        tracker: 'UA-61874544-1',
        name: "Website",
        trackEvent: true
      }
  ]
}




// WEBPACK FOOTER //
// ./local_config.js